var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeycard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_550_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.799927 25.4746C0.799927 27.6065 2.58796 29.3336 4.79513 29.3336H32.8055C35.0119 29.3336 36.8007 27.6073 36.8007 25.4746V25.2744H0.799927V25.4746Z",
    fill: "#272829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2509 15.1003C13.8162 15.1003 14.2745 14.6577 14.2745 14.1117C14.2745 13.5657 13.8162 13.123 13.2509 13.123C12.6857 13.123 12.2274 13.5657 12.2274 14.1117C12.2274 14.6577 12.6857 15.1003 13.2509 15.1003Z",
    fill: "#272829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8032 6.80176H4.79513C2.58796 6.80176 0.799927 8.52959 0.799927 10.6608V20.9269H36.7991V10.66C36.7991 8.52959 35.0103 6.80176 32.8032 6.80176ZM26.3912 14.4311L25.37 15.8435C25.2562 15.9982 25.0741 16.0899 24.8795 16.0914L18.5955 16.1134C17.9 17.3052 16.6112 18.0088 15.1363 18.0133C12.915 18.0217 11.1058 16.2612 11.098 14.1157C11.0893 11.9686 12.8844 10.2286 15.1065 10.2225C16.5916 10.2165 17.8922 10.9617 18.5947 12.149L19.4141 12.146C19.5099 12.1452 19.6001 12.1816 19.6676 12.2476C19.7359 12.312 19.7736 12.4007 19.7736 12.4925V12.494C19.7736 12.6122 19.8497 12.7191 19.962 12.7639C20.075 12.8094 20.2053 12.7821 20.2917 12.6987L20.5577 12.4379C20.6252 12.3719 20.7171 12.3348 20.8136 12.334C20.9086 12.3332 21.0004 12.3704 21.0687 12.4356L21.6001 12.9466C21.6676 13.0118 21.7594 13.0482 21.8552 13.0482C21.951 13.0474 22.0412 13.0103 22.1087 12.9451L22.706 12.3666C22.7728 12.3006 22.8646 12.2643 22.9611 12.2643C23.0561 12.2643 23.1464 12.3006 23.2155 12.3658L23.8167 12.9436C23.958 13.08 24.1856 13.08 24.3253 12.9436L24.8716 12.4144C24.9478 12.3416 25.0514 12.3044 25.1573 12.3128C25.2625 12.3219 25.3598 12.3749 25.4203 12.4576L26.3849 13.7609C26.5348 13.9625 26.5364 14.2301 26.3912 14.4311Z",
    fill: "#272829"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_550_19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.799927,
    y: 0.681641,
    width: 36,
    height: 34.7727,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeycard);
export default __webpack_public_path__ + "static/media/keycard.8a73a7d9dc43d8a69b84a5ad5ab1f332.svg";
export { ForwardRef as ReactComponent };